import React from 'react';

export default function Link({
  width = 13,
  height = 14,
  color = '#616874',
  strokeWidth = '1.5',
  className = '',
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 13 14'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.41901 5.79448L1.93004 7.28345C1.37395 7.83954 1.05416 8.59618 1.06 9.39139C1.06585 10.1866 1.37864 10.9479 1.96111 11.5123C2.52557 12.0948 3.28699 12.4076 4.08207 12.4135C4.89529 12.4194 5.63402 12.1177 6.19014 11.5616L7.67911 10.0726M9.58099 8.20709L11.07 6.71813C11.626 6.16204 11.9458 5.40539 11.94 4.61019C11.9341 3.81498 11.6214 3.05372 11.0389 2.48923C10.4746 1.92491 9.71327 1.6121 8.91806 1.60626C8.12285 1.60041 7.36611 1.90205 6.80999 2.45815L5.32102 3.94712M4.24207 9.2189L8.70898 4.75199'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
